// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1pfhu2gc{margin-block-start:var(--ds-space-100,8px)}\n._1ul91osq{min-width:100%}", ""]);
// Exports
module.exports = exports;
